module.exports = __webpack_public_path__ + "static/img/shuiji3.3831c3c5.webp";